export default __webpack_public_path__ + "static/media/webmin.8b51ef5e.svg";